import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { INPUT_TYPE, STRING } from '../../types';
import { DFormHelpers } from '../../d-form/d-form.helpers';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FORM_STYLE_CONFIG } from '../../d-form/style.config';

@Component({
  selector: 'app-input-group',
  templateUrl: './input-group.component.html',
  styleUrls: ['./input-group.component.css']
})
export class InputGroupComponent implements OnInit {
	@Input() formElement: any = {};
	@Input() formValue: FormControl;
	@Input() formRef: FormGroup;
	@Output() formValueChange = new EventEmitter();
	@Output() formRefChange = new EventEmitter();
	@Output() formBuildCompleted = new EventEmitter();
	@Output()
	change = new EventEmitter<{
		name: string;
		value: string;
	}>();
	@Output()
	blur = new EventEmitter<{
		name: string;
		value: string;
	}>();
	formBuildComplete = false;
	labelClass: any;
	inputClass: any = [];
	rowClass: any;
	appFormGroup: FormGroup;
	INPUT_TYPE = INPUT_TYPE;
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	elementClass: any = STRING.EMPTY;
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {

		this._formatView();
		this.appFormGroup = this._createFormGroup(this.formElement.inputs);
		this.formRef = this.appFormGroup;
		if (this.formValue) {
			this.formValue.setValue(this.formRef);
			this.formRef.valueChanges.subscribe(value => {
				this.formValue.setValue(this.formRef);
			});
		}
		this.formValue.valueChanges.subscribe(data => {
			this.onFormValueChange(data);
		});
		this.formRefChange.emit(this.formRef);
		if (this.formBuildComplete) {
			this.formBuildCompleted.emit();
			this.formBuildComplete = false;
		}
  }

  onFormValueChange(val) {
	  	if (!val || (val instanceof FormGroup)) {
			  return;
		}
	  	if (Helpers.compareObj(this.value, val)) {
			  return;
		}
		// for (const controlName of Object.keys(val)) {
		// 	this.formRef.controls[controlName].setValue(val[controlName]);
		// }
		this.formRef.patchValue(val);
		this.formValue.setValue(this.formRef);
	}


  isDisabled() {
		return (this.formElement.disabled || this.formElement.readOnly) ? STRING.EMPTY : null;
	}

	// private _formatView() {
	// 	this.labelClass = ['col-form-label field-label'];
	// 	this.inputClass = [];
	// 	let derivedLabelClass = [];
	// 	let derivedInputClass = [];
	// 	if (this.formElement.align && this.formElement.align === 6) {
	// 		derivedLabelClass.push('col-4');
	// 		derivedInputClass.push('col-8');
	// 	} else {
	// 		derivedLabelClass.push('col-2');
	// 		derivedInputClass.push('col-10');
	// 	}
	// 	const labelDiv = this.formElement.labelDiv;
	// 	const inputDiv = this.formElement.inputDiv;
	// 	derivedLabelClass = [`col-${labelDiv}`];
	// 	derivedInputClass = [`col-${inputDiv}`];
	// 	if (this.formElement.row) {
	// 		this.rowClass = ['row'];
	// 		derivedLabelClass.push('right-text');
	// 	} else {
	// 		derivedInputClass = ['col-12'];
	// 		derivedLabelClass = ['col-12'];
	// 	}
	// 	this.inputClass = this.inputClass.concat(derivedInputClass);
	// 	this.labelClass = this.labelClass.concat(derivedLabelClass);
	// }

	private _formatView() {
		this.labelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.default];
		const labelDiv = this.formElement.labelDiv;
		const inputDiv = this.formElement.inputDiv;
		let derivedLabelClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(labelDiv)
		];
		let derivedInputClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(inputDiv)
		];
		if (this.formElement.row) {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.row
			];
			derivedLabelClass.push(
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.condition.row
			);
		} else {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.flexRow
			];
			derivedInputClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
			derivedLabelClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
		}
		this.inputClass = this.inputClass.concat(derivedInputClass);
		this.labelClass = this.labelClass.concat(derivedLabelClass);
	}

	private _createFormGroup(formElements: any[]) {
		const group = this.createFormGroupObject(formElements);
		return this.formBuilder.group(group);
	}

	get value() {
		return this.appFormGroup.value;
	}

	onBlur(data) {
		// this.makeDirty();
		// if (this.value === undefined) {
		// 	return;
		// }
		this.blur.emit({
			name: this.formElement.name,
			value: this.value
		});
	}

	onChange() {
	// onChange(data) {
		if (this.value === undefined || Number.isNaN(this.value)) {
			return;
		}
		// this.makeDirty();
		// this.inputValue = this.value;
		// this.valueChange.emit(this.value);
		this.formData = this.value;
		this.change.emit({
			name: this.formElement.name,
			value: this.value
		});
	}

	set formData(value) {
		this.formRef.setValue(value);
	}

	createFormGroupObject(formElements: any[]) {
		const group = {};
		for (const formElement of formElements) {
			const validations = DFormHelpers.createValidations(
				formElement,
				this.formElement.disabled
			);
			if (formElement.lastElement) {
				this.formBuildComplete = true;
			}
			group[formElement.name] = [null, validations];
		}
		return group;
	}


}
